import './rewards.css';
import '@fontsource/open-sauce-one';
import Coupon from './component/Coupon/coupon';
import SpinTheWheel from './component/SpinTheWheel/spinwheel';
import Card from './component/Card/Card';
import React, { useEffect, useState } from 'react';
import Winnings from './component/Winnings/Winnings';
import {useHistory, withRouter} from 'react-router-dom';
import BottomDrawer from './component/Winnings/BottomDrawer';
import baseURLGlobal from '../../utils/util';
import { SOURCE_HOME, } from './util';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';
import Lottie from 'react-lottie';
import studentStripAnimation from '../../assets/json/navratri-strip.json';
import { cosmosTrackService } from '../../cosmosTracking/cosmosTrackService';
import {sale_video_student, Spin_the_wheeler} from '../../cosmosTracking/cosmosEvents';
import { directDeepLink } from '../../tutor/webviewreboot/util';
import TutorMessage from "./component/TutorMessage/TutorMessage";
import splitHighlight from './splitHighlight';
import studentVideo from '../../assets/videos/studentend_video.mp4'
import HeaderImg from '../../assets/images/independence-day-header.png'
import campaignConfig from '../../campaign-config/campaign.json';

const localCampaignAssets = {
	'src/assets/videos/studentend_video.mp4': studentVideo,
	'src/assets/json/navratri-strip.json': studentStripAnimation,
};

const resolveCampaignAsset = (asset) => localCampaignAssets[asset] || asset;

function Rewards() {
	const baseUrl = baseURLGlobal;
	const studentHome = campaignConfig.student_home || {};
	const text = studentHome.text || {};
	const images = studentHome.images || {};
	const colors = studentHome.colors || {};
	const globalColors = campaignConfig.global?.colors || {};
	const backgrounds = studentHome.backgrounds || {};
	const socialProof = splitHighlight(
		text.home_coupon || 'About 80% students won brand vouchers in every festive sale!',
		text.home_coupon_highlight || '80% students'
	);
	const courseHeading = splitHighlight(
		text.course_section_heading || 'Purchase Course & get chance to win amazing brand vouchers!',
		text.course_section_heading_highlight || 'win amazing brand vouchers!'
	);
	const campaignStyle = {
		'--student-page-background-image': `url("${resolveCampaignAsset(images.page_background_image)}")`,
		'--student-wheel-background-image': `url("${resolveCampaignAsset(images.wheel_background_image)}")`,
		'--student-wheel-frame-image': images.wheel_frame_image ? `url("${resolveCampaignAsset(images.wheel_frame_image)}")` : 'none',
		'--student-wheel-brand-sprite-image': images.wheel_brand_sprite_image ? `url("${resolveCampaignAsset(images.wheel_brand_sprite_image)}")` : 'none',
		'--student-campaign-accent': globalColors.accent_color || '#E35C22',
		'--student-campaign-primary-text': globalColors.heading_color || '#232E4F',
		'--student-campaign-warm-text': globalColors.subheading || '#6C2718',
		'--student-campaign-light-surface': globalColors.page_background || '#FEF2DF',
		'--student-campaign-video-border': colors.campaign_video_border_color || '#FFF2C8',
		'--student-social-proof-border': globalColors.accent_color || '#E35C22',
		'--student-home-coupon-text': globalColors.body_text || '#040E1A',
		'--student-home-coupon-highlight': globalColors.accent_color || '#E35C22',
		'--student-spin-section-description-text': globalColors.subheading || '#6C2718',
		'--student-course-carousel-pagination-inactive': globalColors.accent_color || '#E35C22',
		'--student-course-carousel-pagination-active': globalColors.accent_color || '#E35C22',
		'--student-reward-card-border': colors.spin_card_border_color || globalColors.accent_color || '#E35C22',
		'--student-primary-cta-background': globalColors.accent_color || '#E35C22',
		'--student-tutor-message-border': globalColors.accent_color || '#E35C22',
		'--student-voucher-accent': globalColors.accent_color || '#E35C22',
		'--student-course-coupon-badge-background': globalColors.accent_color || '#E35C22',
		'--student-course-final-price-text': globalColors.accent_color || '#E35C22',
		'--student-maroon-accent': globalColors.dark_accent || 'rgba(125, 25, 63, 1)',
		'--student-course-card-border': colors.course_card_border_color || globalColors.subheading || '#6C2718',
		'--student-course-card-shadow': '#00000033',
		'--student-course-card-image-shadow': '#00000040',
		'--student-course-original-price-text': colors.course_card_original_price_text_color || 'rgba(112, 112, 118, 1)',
		'--student-course-coupon-badge-text': globalColors.white_text || '#FFFFFF',
		'--student-course-coupon-badge-shadow': '#FFFFFF40',
		'--student-course-buy-button-text': globalColors.button_text || '#FFFFFF',
		'--student-course-buy-button-shadow': 'rgba(255, 255, 255, 0.25)',
		'--student-course-card-background': backgrounds.course_card_background || globalColors.page_background || '#FEF2DF',
		'--student-spin-card-background': backgrounds.spin_card_background || globalColors.page_background || '#FEF2DF',
		'--student-reward-card-background': globalColors.page_background || '#FEF2DF',
		'--student-voucher-code-background': backgrounds.voucher_code_background || '#FFFFFF66',
		'--student-winnings-copy-button-text': globalColors.button_text || '#ffffff',
		'--student-winnings-copy-button-background': globalColors.copy_cta || '#3CA153',
		'--student-coupon-modal-card-background': backgrounds.coupon_modal_card_background || globalColors.accent_color || '#E35C22',
		'--student-coupon-modal-card-border': colors.coupon_modal_card_border_color || 'rgba(255, 255, 255, 0.8)',
		'--student-coupon-modal-reward-text': globalColors.white_text || '#ffffff',
		'--student-coupon-modal-voucher-code-border': colors.coupon_modal_voucher_code_border_color || '#FFFFFF',
		'--student-coupon-modal-voucher-code-text': globalColors.white_text || '#ffffff',
		'--student-coupon-modal-voucher-code-label-text': globalColors.white_text || '#ffffff',
		'--student-coupon-modal-copy-button-background': backgrounds.coupon_modal_copy_button_background || '#ffffff',
		'--student-coupon-modal-title-text': globalColors.white_text || '#fff',
		'--student-coupon-instruction-text': globalColors.white_text || '#fff',
		'--student-spin-launch-button-text': globalColors.button_text || '#FFF',
		'--student-spin-wheel-button-text': globalColors.button_text || 'white',
		'--student-spin-wheel-button-shadow': 'rgba(255, 255, 255, 0.25)',
		'--student-wheel-locked-message-text': globalColors.white_text || '#fff',
		'--student-tutor-message-card-gradient': backgrounds.tutor_message_card_gradient || 'linear-gradient(148.05deg, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0) 100%, rgba(255, 255, 255, 0) 100%)',
	};
	const [data, setData] = useState({});
	const [rotating, setRotating] = useState(false);
	const [redeeming, setRedeeming] = useState(false);
	const [spinError, setSpinError] = useState('');
	const [openModals, setOpenModals] = useState(false);
	const [modalsData, setModalsData] = useState();
	const [winnings, setWinnings] = useState(0);
	const [promoTypeId, setPromoTypeId] = useState('');
	const [showBottomDrawer, setShowBottomDrawer] = useState(false);
	const [spinnerModal, setSpinnerModal] = useState(false);
	const [drawerContent, setDrawerContent] = useState({});

	const stripAnimation = {
		loop: true,
		autoplay: true,
		animationData: resolveCampaignAsset(images.social_proof_animation || 'src/assets/json/navratri-strip.json'),
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	let url = new URL(window.location.href);
	let token = url.searchParams.get('token');

	const handleDrawerOpen = (drawerContent) => {
		setDrawerContent(drawerContent);
		setShowBottomDrawer(true);
	};
	const handleDrawerClose = () => {
		setDrawerContent({});
		setShowBottomDrawer(false);
	};

	const handleModals = () => {
		setSpinError('');
		setRotating(true);
	};

	const _postSpinHandler = async () => {
		setRedeeming(true);
		const award = await postAwards();
		setRotating(false);
		setRedeeming(false);
		if (award) {
			setOpenModals(true);
		} else {
			setSpinError('Unable to load your reward. Please try again.');
		}
	};

	const postAwards = async () => {
		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: JSON.stringify({ promoTypeId }),
		};

		return await fetch(
			`${baseUrl}/v2/course/campaign/student/award/redeemVoucher`, requestOptions
		)
			.then((response) => response.json())
			.then((results) => {
				setModalsData(results.data);
				return results.data;
			})
			.catch((error) => {
				console.log('error', error);
				return null;
			});
	};

	const getAwards = () => {
		let myHeaders = new Headers();
		myHeaders.append('api-version', '25');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v2/course/campaign/student/home`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				console.log(result, 'dddd')
				setData(result) ;
				let winnerobj = result?.data?.userAwards?.scratchCards.find(
					(res) => res?.winner
				);
				setPromoTypeId(winnerobj?.id);
			})
			.catch((error) => console.log('error', error));
	};

	const handleSpinBtn = function (){
		if (rotating || redeeming) return;
		if (!data?.data?.userAwards?.scratchCards?.some((prize) => prize.winner)) {
			setSpinError('Rewards are not loaded. Please reopen the wheel and try again.');
			return;
		}
		let DeepLink = {
			screen: '',
			paramOne: '',
			paramTwo: '',
			paramTracking: 'StudentSideSpinWheelClickTracking',
			paramThree: '',
			paramSource: '',
		};
		handleModals();
		window?.mobile?.onDeeplinkExecutedV2?.(
			JSON.stringify(DeepLink)
		);
		directDeepLink(DeepLink, SOURCE_HOME);
	}

	const handleCouponModal = function (){
		setTimeout(() => {
			setOpenModals(false);
			setSpinnerModal(false);
		}, 2000);
		setWinnings(winnings + 1);
	}
	const isIphone = () => {
		return /iPhone/i.test(navigator.userAgent);
	};

	useEffect(() => {
		getAwards();
	}, [winnings]);
	return (
		<div className="layoutBackground" id="Background" style={campaignStyle}>
			<div className="student-page-header">
				<img src={resolveCampaignAsset(images.header_banner) || HeaderImg} alt="title" />
				{studentHome.video_enabled !== false && images.campaign_video && (
				<video
					poster={images.campaign_video_poster || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/video-thumbnail-dark.png'}
					key={images.campaign_video}
					src={resolveCampaignAsset(images.campaign_video)}
					controls
					controlsList="nofullscreen nodownload noplaybackrate"
					disablePictureInPicture
					playsInline
					onPlay={()=>cosmosTrackService(sale_video_student)}>
				</video>
				)}
				{
					!isIphone() ?
				<div className="bottom-coupon-box">
					<img src={resolveCampaignAsset(images.social_proof_icon)} width={24} alt="img"/>
					<p>
						{socialProof.before}{socialProof.highlight && <span>{socialProof.highlight}</span>}{socialProof.after}
					</p>
					<Lottie options={stripAnimation}></Lottie>
				</div> :
						<img className="bottom-coupon-img-box" src={resolveCampaignAsset(images.social_proof_fallback_image)} alt="fallback"/>
				}
			</div>
			{
				data?.data?.campaignTutorMessage &&
				<TutorMessage message={data?.data?.campaignTutorMessage} orgLogo={data?.data?.campaignOrg?.appLogo} orgName={data?.data?.campaignOrg?.orgName} heading={text.tutor_message_heading} headingHighlight={text.tutor_message_heading_highlight}/>
			}
			{data?.data?.courses &&
				<div className="layoutSlider">
					<h2>{courseHeading.before}{courseHeading.highlight && <span style={{color: globalColors.accent_color || '#E35C22'}}>{courseHeading.highlight}</span>}{courseHeading.after}</h2>
					<Swiper className="layoutSwiper"
							pagination={{clickable: true}}
							modules={[Pagination]} slidesPerView={1.1}>
						{data?.data?.courses?.map((item, index)=>{
							return(
								<SwiperSlide key={item.id || index}>
									<Card data={item} buyButtonLabel={text.buy_button_label} discountBadgeIcon={images.course_discount_badge_icon}/>
								</SwiperSlide>
							)
						})}
					</Swiper>
				</div>
			}
			<div className="layoutReward">
				<h4>{text.spin_section_title || 'Spin and Win'}</h4>
				<p>{text.spin_section_description || 'Choose your favorite brand and spin the wheel to get exciting vouchers of that brand.'}</p>
				<div className="RewardCard">
					<img src={images.spin_promotion_image || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/christmas-spin-aniamtiongif.gif'} alt="animation"/>
					<button onClick={() => {cosmosTrackService(Spin_the_wheeler);setSpinnerModal(true);}}>{text.spin_launch_button_label || 'Spin Now'}</button>
				</div>
			</div>
			{spinnerModal &&
				<div className="spinModalOverlay">
					<div className="overlayClose" onClick={() => {if (!rotating && !redeeming) {setSpinnerModal(false);setSpinError('');}}}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={18}/>
					</div>
					<div className="overlayContent">
						<SpinTheWheel
							prizeList={data?.data?.userAwards?.scratchCards}
							rotating={rotating}
							postSpinHandler={_postSpinHandler}
						/>
						{data?.data?.userAwards?.scratch ?(
								<button className="overlayActionBtn" onClick={handleSpinBtn} disabled={rotating || redeeming}>{text.spin_button_label || 'Tap to Spin'}</button> ):
							(
								<>
									<button className="overlayActionBtn" disabled={true}>{text.spin_button_label || 'Tap to Spin'}</button>
									<p>{text.wheel_locked_message || 'Purchase a course above ₹100 to unlock the wheel'}</p>
								</>
							)
						}
						
						{spinError && <p role="alert">{spinError}</p>}
					</div>
				</div>
			}
			
			{data?.data?.userAwards?.awardsList &&
				<div className="layoutWining">
					<h4>{text.winnings_section_title || 'Your Winnings'}</h4>
					<div className="WinnerCardGroup">
						{data?.data?.userAwards?.awardsList?.map((item) => (
							item.id === 44 ? null : (
								<Winnings
									key={item.id}
									data={item}
									handleDrawerOpen={handleDrawerOpen}
									copyButtonLabel={text.winnings_copy_button_label}
									voucherCodeLabel={text.winnings_voucher_code_label}
									howToRedeemLabel={text.winnings_how_to_redeem_label}
								/>
							)
						))}
					</div>
				</div>
			}

			{openModals &&
				<div className="couponModalOverlay">
					<div className="overlayClose" onClick={handleCouponModal}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={18}/>
					</div>
					<div className="overlayContent">
						<h4>{text.coupon_modal_title || 'Congratulations!!'}</h4>
						<Coupon
							datas={modalsData}
							revealBackground={images.coupon_reveal_background_image}
							copyButtonLabel={text.coupon_modal_copy_button_label}
							voucherCodeLabel={text.coupon_modal_voucher_code_label}
							noWinMessage={text.coupon_modal_no_win_message}
						/>
						<p>{text.coupon_instruction || 'Copy the Coupon code to redeem'}</p>
					</div>
				</div>
			}
			{showBottomDrawer && (
				<BottomDrawer
					drawerContent={drawerContent}
					closeDrawer={handleDrawerClose}
				/>
			)}
		</div>
	);
}

export default withRouter(Rewards);
